import React from 'react';
import Label from "../../UI/Label";
import { arrowWidth, trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const renderLabel = (coords, color, onLabelClick) => (
	<Label
		onClick={(event, ref) => onLabelClick(event, ref, 'Track1EBlue')}
		coords={coords}
		text="1E"
		textCoordsX="11.6777344"
		colors={color}
	/>
);

const Track1EBlue = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE);
	return (
		<>
			<g id="Track1EBlue" transform="translate(965.000000, 707.000000)" className="track">
				<g stroke={trackColor} strokeWidth={tracksWidth}>
					<line
						x1="124.954837" y1="344.340913" x2="146" y2="300" id="BlueConnector-1EBlue1BBlack1ARed"
						strokeLinecap="round" className="connector"/>

					<polyline
						id="arrow" strokeWidth={arrowWidth}
						stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
						strokeLinecap="round" strokeLinejoin="round"
						transform="translate(260.000000, 105.000000) rotate(-186.000000) translate(-260.000000, -105.000000) "
						points="264 113 256 105 264 97"/>

					<polyline
						id="arrow" strokeWidth={arrowWidth}
						stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
						strokeLinecap="round" strokeLinejoin="round"
						transform="translate(106.000000, 59.000000) rotate(-45.000000) translate(-106.000000, -59.000000) "
						points="110 67 102 59 110 51"
					/>

					<g id="line" transform="translate(105.000000, 0.000000)">
						<path
							d="M0,60.5 L25.2949,34.0256 C30.2259,28.8066 29.9909,20.5786 24.7719,15.6486 C24.1999,15.1076 23.5799,14.6206 22.9199,14.1926 L2.0889,0.6776"
							strokeLinecap="round"
						/>
					</g>

					<path
						d="M146,300 L127.948978,227.846744 C126.738478,223.406784 127.96559,218.657704 131.175442,215.359917 C134.703138,211.735579 137.499732,208.862371 139.565224,206.740294 M146.873506,199.231799 C153.557,192.365209 182.810232,162.287942 234.633203,109 C140.938513,122.49801 89.6203837,129.946054 80.678815,131.344131 M67,134.223371 L0.907801542,143.5 M0.907801542,142.537702 L22.8655431,132.911045 M33.4583518,128 C41.8824275,121.303631 47.5262382,116.65022 50.389784,114.039768 C58.4838939,106.661055 63.6143279,101.89766 65.7810861,99.7495833 L96.798088,69"
						id="TrackLine"
						strokeLinecap="round"/>

					<TrackArrow
						transform="translate(148.846454, 197.192410) rotate(-405.000000) translate(-148.846454, -197.192410) "
						points="152.846454 205.19241 144.846454 197.19241 152.846454 189.19241"/>

					<TrackArrow
						transform="translate(35.480032, 126.583726) rotate(-34.000000) translate(-35.480032, -126.583726) "
						points="39.4800323 134.583726 31.4800323 126.583726 39.4800323 118.583726"/>

					<TrackArrow
						transform="translate(63.950034, 134.788966) rotate(-191.000000) translate(-63.950034, -134.788966) "
						points="67.9500344 142.788966 59.9500344 134.788966 67.9500344 126.788966"/>
				</g>

				{renderLabel('117.907684, 102.681737',
					getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE),
					onLabelClick
				)}

				{renderLabel('150.907684, 158.681737',
					getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE),
					onLabelClick
				)}

				{renderLabel('62.907684, 66.681737',
					getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE),
					onLabelClick
				)}
			</g>

			<g transform="translate(1165.000000, 812.000000)"
				 stroke={trackColor}
				 strokeLinecap="round"
				 strokeWidth={tracksWidth}
			>
				<line x1="62" y1="1.13686838e-13" x2="2.87769808e-13" y2="9"/>
			</g>

			{/*<g*/}
			{/*   id="Track-1E-Connector"*/}
			{/*   stroke={trackColor}*/}
			{/*   strokeWidth={tracksWidth}*/}
			{/*   strokeLinecap="round"*/}
			{/*   transform="translate(1156.000000, 810.500000)"*/}
			{/*   style={{opacity: 0}}*/}
			{/*>*/}
			{/*   <line x1="69" y1="1" x2="1" y2="9"/>*/}
			{/*</g>*/}
		</>
	)
};

Track1EBlue.propTypes = trackPropTypes;

export default Track1EBlue;
